/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SendDocumentsAliases {
  CHECKBOX_VALIDITY = 'checkbox-validity',
  DATE_FIELD_EMISSION = 'date-field-emission',
  DATE_FIELD_VALIDITY = 'date-field-validity',
  FETCH_DOCUMENTS = 'fetch-documents',
  FIELD_0 = 'field-0',
  FIELD_CHECKBOX = 'field-checkbox',
  FIELD_EMISSION_DATE = 'field-emission-date',
  FIELD_UPLOADER = 'field-uploader',
  FIELD_VALIDITY = 'field-validity',
  FILE_UPLOADER = 'file-uploader',
  FORM_SEND_DOCS = 'form-send-docs',
  PANEL_MODAL = 'panel-modal',
  TEXT_2 = 'text-2',
}
export { SendDocumentsAliases };
